import React from 'react';
import {
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Facilities = () => {
  const navigate = useNavigate();
  
  const facilities = [
    { 
      id: 1, 
      name: 'Shipyard Gdansk', 
      location: 'Gdansk, Poland',
      capacity: '5 ships',
      status: 'Active'
    }
  ];

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        Facilities
      </Typography>
      <Grid container spacing={3}>
        {facilities.map((facility) => (
          <Grid item xs={12} md={6} key={facility.id}>
            <Card>
              <CardContent>
                <Typography variant="h5" component="div">
                  {facility.name}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  Location: {facility.location}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Capacity: {facility.capacity}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Status: {facility.status}
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="small" onClick={() => navigate(`/facilities/${facility.id}`)}>View Details</Button>
                <Button size="small">Manage</Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default Facilities;